"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "clone", {
  enumerable: true,
  get: function get() {
    return _objectHelpers.clone;
  }
});
Object.defineProperty(exports, "deepEquals", {
  enumerable: true,
  get: function get() {
    return _objectHelpers.deepEquals;
  }
});
Object.defineProperty(exports, "sorter", {
  enumerable: true,
  get: function get() {
    return _objectHelpers.sorter;
  }
});
Object.defineProperty(exports, "smartCompare", {
  enumerable: true,
  get: function get() {
    return _objectHelpers.smartCompare;
  }
});
Object.defineProperty(exports, "immutableDeepMerge", {
  enumerable: true,
  get: function get() {
    return _immutableDeepMerge.immutableDeepMerge;
  }
});
Object.defineProperty(exports, "make", {
  enumerable: true,
  get: function get() {
    return _undefinedToKey["default"];
  }
});
exports.S = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _Dates = require("../v2/utils/Dates");

var _objectHelpers = require("./objectHelpers");

var _immutableDeepMerge = require("./immutableDeepMerge");

var _undefinedToKey = _interopRequireDefault(require("./undefinedToKey"));

var S = _interopRequireWildcard(require("./sanctuary.js"));

exports.S = S;

// localise moment so the react-datetime component will show translated text
if (typeof PHGC != 'undefined') {
  var _PHGC, _PHGC$userData;

  /* eslint-disable no-undef, flowtype/require-parameter-type */
  var currentLocale = ((_PHGC = PHGC) === null || _PHGC === void 0 ? void 0 : (_PHGC$userData = _PHGC.userData) === null || _PHGC$userData === void 0 ? void 0 : _PHGC$userData.user_locale) || 'en';

  if (_moment["default"].locale() != currentLocale && _Dates.localeHash[currentLocale]) {
    // if there is the need and the chance to update the locale data
    var localeData = _Dates.localeHash[currentLocale];

    _moment["default"].defineLocale(currentLocale, {
      parentLocale: 'en',
      weekdaysMin: Array(7).fill(0).map(function (_, ind) {
        return localeData.localize.day(ind, {
          width: 'short'
        });
      }),
      months: Array(12).fill(0).map(function (_, ind) {
        return localeData.localize.month(ind, {
          width: 'wide'
        });
      }),
      monthsShort: Array(12).fill(0).map(function (_, ind) {
        return localeData.localize.month(ind, {
          width: 'short'
        });
      }),
      week: {
        doy: localeData.options.firstWeekContainsDate,
        dow: 1 // "monday" is hard coded elsewhere so it must be a sitewide convention

      }
    });
  }
}
//# sourceMappingURL=index.js.map